import React from 'react';

function MyPage() {
    return (
        <div id="memberscss">
            <div id="wrap">
                <div id="container">
                    <div className="mypageWrap">
                        <div className="stateDesc">
                            <div className="userInfo">
                                <span>정인성</span>님의 서비스 이용현황
                                <a href="">
                                    나의 상세정보 확인 <span className="icon-step-arrow"></span>
                                </a>
                            </div>
                            <div className="desc">
                                <div className="linkArea">
                                    <p className="eng">PLAYAPI</p>
                                    <a href="">
                                        1:1문의 <span className="icon-arrow_mini"></span>
                                    </a>
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>계약 과금</th>
                                            <th>예치금</th>
                                            <th>서비스 계약 만료일</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>건당 (100원)</td>
                                            <td>
                                                100,000<span>원</span>
                                            </td>
                                            <td>
                                                2022-11-30 (<span>700</span>일 남음)
                                            </td>
                                            <td>
                                                <button>세부정보확인</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="bg-lightGray">
                            <div className="notice">
                                <strong>유의사항</strong>
                                - 계약 방식에 따라 계약과금, 예치금은 노출되지 않을 수 있습니다. <br />- 설정된 사용
                                만료일이 지난 경우 API 인증키는 차단되며, 담당자와 협의 해주시기 바랍니다. <br />-
                                세부정보의 당일 사용량은 카운트 갱신 시간에 따라 실제 사용량과 상이할 수 있습니다.
                            </div>
                        </div>
                        <div className="detail">
                            <h3 className="sectionTitle">세부정보</h3>
                            <div className="tabArea">
                                <p className="active">일일</p>
                                <p>주간</p>
                                <p>월간</p>
                            </div>
                            <table className="table-basic">
                                <colgroup>
                                    <col width="10%" />
                                    <col width="50%" />
                                    <col width="40%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>일자</th>
                                        <th>API 호출량</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>01</td>
                                        <td>2021-01-20</td>
                                        <td>
                                            <span>100</span>건
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>01</td>
                                        <td>2021-01-20</td>
                                        <td>
                                            <span>100</span>건
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>01</td>
                                        <td>2021-01-20</td>
                                        <td>
                                            <span>100</span>건
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="pagenation">
                                <button className="prevBtn disable">
                                    <span className="icon-step-arrow"></span>
                                </button>
                                <ol>
                                    <li className="active">1</li>
                                    <li>2</li>
                                    <li>3</li>
                                    <li>4</li>
                                    <li>5</li>
                                    <li>&hellip;</li>
                                    <li>10</li>
                                </ol>
                                <button className="nextBtn">
                                    <span className="icon-step-arrow"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MyPage;
